module.exports = __webpack_public_path__ + "img/giftcount.fca35a7f.svg";